export default __webpack_public_path__ + "static/media/logo_novaland.62132101.png";